import { render, staticRenderFns } from "./ExploreConsumer.vue?vue&type=template&id=0fd068cd&scoped=true"
import script from "./ExploreConsumer.vue?vue&type=script&lang=js"
export * from "./ExploreConsumer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd068cd",
  null
  
)

export default component.exports